import { Star, ExternalLink } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { GOOGLE_REVIEW_URL } from "../data/content";

export const GoogleReview = () => (
  <section className="relative pb-16 sm:pb-24 pt-4 sm:pt-8">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <div className="flex justify-center">
          <Overline>Sua opinião vale desconto</Overline>
        </div>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl font-extrabold tracking-tight">
          Já foi atendido? <span className="gold-text">Avalie a Gold</span>
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <a
          data-testid="google-review-banner"
          href={GOOGLE_REVIEW_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group mt-8 block relative overflow-hidden rounded-3xl border border-gold/30 transition-all duration-500 hover:border-gold/70 hover:shadow-[0_25px_80px_-25px_rgba(212,175,55,0.45)] hover:-translate-y-1"
        >
          <img
            src="/images/google-avaliacao.jpg"
            alt="Nos avalie no Google e ganhe 10% de desconto no serviço"
            loading="lazy"
            className="w-full transition-transform duration-700 group-hover:scale-[1.02]"
          />
        </a>
        <div className="mt-6 flex justify-center">
          <a
            data-testid="google-review-button"
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 rounded-full bg-gold px-7 py-4 font-bold text-ink text-sm sm:text-base transition-all duration-300 hover:shadow-[0_0_40px_rgba(212,175,55,0.4)] hover:-translate-y-0.5"
          >
            <span className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-current" />
              ))}
            </span>
            Avaliar no Google
            <ExternalLink className="h-4 w-4" />
          </a>
        </div>
        <p className="mt-3 text-center text-[11px] uppercase tracking-[0.25em] text-mist">
          Avaliou? Ganhe 10% de desconto no próximo serviço
        </p>
      </Reveal>
    </div>
  </section>
);
